export const CAPTION_EDITOR_KEY = 'CAPTION';
